import { initial, last } from 'lodash';

import isPageBreak from './isPageBreak';

export default blocks => (isPageBreak(last(blocks)) ? initial(blocks) : blocks);
